import { render, staticRenderFns } from "./estimates-edit.vue?vue&type=template&id=0b310405&scoped=true"
import script from "./estimates-edit.vue?vue&type=script&lang=js"
export * from "./estimates-edit.vue?vue&type=script&lang=js"
import style0 from "./estimates-edit.vue?vue&type=style&index=0&id=0b310405&prod&lang=css"
import style1 from "./estimates-edit.vue?vue&type=style&index=1&id=0b310405&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b310405",
  null
  
)

export default component.exports